import { useHistory } from 'react-router-dom';
import Parser from 'html-react-parser';
import l from '../../../../lang';
import { Routes } from '../../../../config/routes';
import CheckIcon from '../../../../assets/icons/check.svg';
import ButtonLink from '../../../common/button-link';
import CardTitle from '../../../common/card-title';
import Card from '../../../common/card';
import CardInfo from '../../../common/card-info';
import { segmentHomeKycStep2Complete, segmentHomeQuickLinkEditCountries } from '../../../../utils/analytics';

interface FirstTimeCardsProps {
  shouldAnimationsRun: boolean;
  maxAmount: number;
}

const FirstTimeCards = ({ shouldAnimationsRun, maxAmount }: FirstTimeCardsProps) => {
  const history = useHistory();

  const onPaymentMethodsHandler = () => {
    segmentHomeQuickLinkEditCountries();
    history.push(Routes.PAYMENT_METHODS);
  };

  const onCompanyInformationHandler = () => {
    segmentHomeKycStep2Complete();
    history.push(Routes.COMPANY_INFORMATION);
  }

  return (
    <Card>
      <CardTitle>{l('home.readyMsg.firstTime')}</CardTitle>
      <div className={`two-cards ${shouldAnimationsRun ? 'card__animated' : ''}`}>
        <CardInfo bottomElement={<div className="card__accentuate-line" />}>
          <div className="card__title card__with-icon">
            <img src={CheckIcon} alt="checked" className="icon-dlocal-color" />
            {l('home.readyMsg.countries.title')}
          </div>
          <div className="card__desc">{Parser(l('home.readyMsg.countries.desc'))}</div>
          <div className="card__desc">
            {Parser(l('home.readyMsg.countries.foot.part1'))}
            <ButtonLink text={l('home.readyMsg.countries.foot.link')} onClick={onPaymentMethodsHandler} />
            {Parser(l('home.readyMsg.countries.foot.part2'))}
          </div>
        </CardInfo>

        <CardInfo bottomElement={<div className="card__accentuate-line" />}>
          <div className="card__title card__with-icon">
            <img src={CheckIcon} alt="checked" className="icon-dlocal-color" />
            {l('home.readyMsg.paso2.title', maxAmount)}
          </div>
          <div className="card__desc">
            <ButtonLink text={l('home.readyMsg.paso2.link')} onClick={onCompanyInformationHandler} />
            {Parser(l('home.readyMsg.paso2.desc'))}
          </div>
        </CardInfo>
      </div>
    </Card>
  );
};

export default FirstTimeCards;
